import { render, staticRenderFns } from "./riskTargetSafetyInfoDetail.vue?vue&type=template&id=08bd495c"
import script from "./riskTargetSafetyInfoDetail.vue?vue&type=script&lang=js"
export * from "./riskTargetSafetyInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bd495c')) {
      api.createRecord('08bd495c', component.options)
    } else {
      api.reload('08bd495c', component.options)
    }
    module.hot.accept("./riskTargetSafetyInfoDetail.vue?vue&type=template&id=08bd495c", function () {
      api.rerender('08bd495c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskTargetSafetyInfoDetail.vue"
export default component.exports